export default (): string => {
  const carouselElements = document.querySelectorAll('.js-carousel');
  if (carouselElements.length) {
    carouselElements.forEach(async (element) => {
      const { default: Carousel } = await import(/* webpackChunkName: "carousel" */ '../components/carousel/carousel');

      return new Carousel(element as HTMLElement);
    });
  }
  return null;
};
